import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { RunningHourEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class RunningHourGroupSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    runningHourGroupUpdated$() {
        return this.socketService.receiveMessageObserver(RunningHourEvents.RUNNING_HOUR_GROUP_UPDATED);
    }
}
